import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Star } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ReviewDialog({ collab, onClose, onDone }) {
    const [rating, setRating] = useState(5);
    const [comment, setComment] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async () => {
        setBusy(true);
        try {
            await api.post("/reviews", { collaboration_id: collab.id, rating, comment });
            toast.success("Recensione inviata");
            onDone?.();
            onClose();
        } catch (e) {
            toast.error(formatApiError(e.response?.data?.detail));
        } finally { setBusy(false); }
    };

    return (
        <Dialog open={!!collab} onOpenChange={(o) => !o && onClose()}>
            <DialogContent data-testid="review-dialog">
                <DialogHeader>
                    <DialogTitle>Lascia una recensione</DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                    <div className="flex items-center gap-2">
                        {[1,2,3,4,5].map((n) => (
                            <button key={n} onClick={() => setRating(n)} type="button" data-testid={`star-${n}`}>
                                <Star className={`w-8 h-8 ${n <= rating ? "fill-[#D96C5B] text-[#D96C5B]" : "text-[#E5E5E0]"}`} />
                            </button>
                        ))}
                    </div>
                    <Textarea rows={4} placeholder="Il tuo commento (opzionale)" value={comment} onChange={(e) => setComment(e.target.value)} data-testid="review-comment" />
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={onClose}>Annulla</Button>
                    <Button onClick={submit} disabled={busy} className="bg-[#1C3F39] hover:bg-[#2A5C53]" data-testid="submit-review-btn">
                        {busy ? "Invio…" : "Invia recensione"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
